export default "{{#each servicesPopular.models}}\n    {{>partialServiceRow business=../business}}\n{{/each}}\n";